const ConditionStatus = `
  id
  description
  updatedAt
`;

export default ConditionStatus;
